<script lang="ts">
  import FeatherIcons from "svelte-feather-icon";
  import Link from "svelte-link";
  import { Button, Col, Form, FormGroup, Input, Label, Modal, ModalBody, ModalHeader, Row } from "sveltestrap";
  import { Cancel, CreateTag, Save, TagName, Tagcolor ,Tags, href} from "../../../utils/Constant/Constant";
  import TagsTabSub from "./TagsTabSub.svelte";
  let open:boolean = false
  // for modal open
  const toggle = (e) => {
    e.preventDefault()
    open = !open
  };
</script>
<li>
  <span class="main-title">{Tags}
    <span class="pull-right">
        <Link href={href} on:click={toggle}>
          <FeatherIcons icon="plus-circle" />
        </Link>
    </span>
  </span>
</li>
<div class="fade modal-bookmark" id="createtag" role="dialog">
  <Modal class="modal-dialog modal-lg" isOpen={open} {toggle} role="document">
    <div class="modal-content">
      <ModalHeader {toggle}>
        <h5 class="modal-title">{CreateTag}</h5>
      </ModalHeader>
      <ModalBody>
        <Form class="form-bookmark needs-validation" novalidate>
          <Row>
            <FormGroup >
              <Col md="12">
                <Label>{TagName}</Label>
                <Input type="text" required autocomplete="off" />
              </Col>
            </FormGroup>
            <FormGroup class="mb-0">
              <Col md="12">
                <Label>{Tagcolor}</Label>
                <Input class="fill-color" type="color" value="#24695c" />
              </Col >
            </FormGroup>
          </Row>
          <Button color="secondary" on:click={(e)=>toggle(e)} >{Save}</Button>
          <Button color="primary" on:click={(e)=>toggle(e)}>{Cancel}</Button>
        </Form>
      </ModalBody>
    </div>
  </Modal>
</div>
<TagsTabSub />

